import * as React from "react";

export const SvgInsta = (props) => (
	<svg width={40} height={38} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M22.619 11.485h-5.686a4.739 4.739 0 0 0-4.739 4.739v5.686a4.739 4.739 0 0 0 4.739 4.739h5.686a4.739 4.739 0 0 0 4.739-4.739v-5.686a4.739 4.739 0 0 0-4.739-4.739Zm3.317 10.425a3.32 3.32 0 0 1-3.317 3.317h-5.686a3.32 3.32 0 0 1-3.317-3.317v-5.686a3.32 3.32 0 0 1 3.317-3.317h5.686a3.32 3.32 0 0 1 3.317 3.317v5.686Z"
			fill="#FFB11A"
		/>
		<path
			d="M19.776 15.276a3.791 3.791 0 1 0 0 7.582 3.791 3.791 0 0 0 0-7.582Zm0 6.16a2.373 2.373 0 0 1-2.37-2.37 2.372 2.372 0 0 1 2.37-2.368 2.372 2.372 0 0 1 2.37 2.369 2.373 2.373 0 0 1-2.37 2.37Z"
			fill="#FFB11A"
		/>
		<circle cx={23.851} cy={14.992} fill="#FFB11A" r={0.505} />
		<path d="M39 19c0 10.205-8.494 18.5-19 18.5S1 29.205 1 19 9.494.5 20 .5 39 8.795 39 19Z" stroke="#FFB11A" />
	</svg>
);
